// START_MODULE components_organisms_navbar_helpers_getactivesection_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import { Section } from 'routes/section';

declare global {
  interface Window {
    SECTION_ELEMS: Record<string, HTMLElement>;
  }
}

window.SECTION_ELEMS = {};

const getSectionElems = () => Object.values(Section).reduce((prev, section) => ({
  ...prev,
  [section]: document.getElementById(section),
}), {});

export const getActiveSection = () => Object.values(Section).find((section) => {
  if (!Object.values(window.SECTION_ELEMS).length) {
    window.SECTION_ELEMS = getSectionElems();
  }

  const top = window.SECTION_ELEMS[section].getBoundingClientRect().top ?? Math.random();
  return top > -100;
});

// END_MODULE components_organisms_navbar_helpers_getactivesection_ts
